import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, List, ListItem, IconButton, Typography, Divider, CircularProgress, Tooltip, Button, TextField } from "@mui/material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { tagActions } from "../../actions/tag.action";

import { useNavigate } from "react-router-dom";
import { currencyFormat } from "../../helpers/common";

//Components
// import Header from "../../Components/Header";
// import ArchiveBudget from "../../Components/Budget";
import axiosInstance from "../../interceptor/interceptor";

// import Footer from '../../Components/Footer';
const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));
  

const TagList = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [showCreate, setShowCreate] = React.useState(false);

    const tagList = useSelector((state) => state.tagReducer.tags);
    const currency = localStorage.getItem('currency');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [inputField, setInputField] = React.useState({
        user_id: localStorage.getItem("user_text_obj_data1"),
        tag_id: "",
        name: "",
      });

    const inputsHandler = (e) => {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
    
    
    function moveBack(){
        navigate("/web");
      }

      useEffect(() => {
        fetchTags();
      }, []);

      // Fetch tags
      function fetchTags() {
        try {
          const user_id = localStorage.getItem("user_text_obj_data1");
          dispatch(tagActions.fetchTags({ user_id: user_id }));
        } catch (e) {
          alert(e);
        }
      }
      function showEditForm(data){
        setInputField({
          tag_id: data.tag_id,
          name: data.name,
          user_id: localStorage.getItem("user_text_obj_data1")
      });
      setShowCreate(true);
      }

      // useEffect(()=>{
      //   setInputField({
      //     tag_id: editObject.tag_id,
      //     name: editObject.name,
      //     user_id: localStorage.getItem("user_text_obj_data1")
      // });
      // setShowCreate(true);
      // }, [num]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const res = await axiosInstance.post(
              `api?method=create_tag`,
              {name:inputField.name, user_id:inputField.user_id,tag_id: inputField.tag_id}
            );
            setIsLoading(false);
            toast(res.data.message);
            setInputField({ ...inputField, name:"", tag_id:"" });
            setShowCreate(false);
            setTimeout(()=>{
              dispatch(
                tagActions.fetchTags({
                  user_id: localStorage.getItem("user_text_obj_data1")
                })
              );
            },0)
            
            
            
        } catch (e) {
          toast.info(`Error: ${e}`, { type: "error" });
        }
      };

      const tagArchiveHandler = async (tag_id, status, msg) => {
        try {
          let result = window.confirm(msg);
          if (result) {
            setIsLoading(true);
            const res = await axiosInstance.post(
              `api?method=update_tag_status`,
              { tag_id: tag_id, status: status }
            );
            setIsLoading(false);
            toast(res.data.message);
            setTimeout(()=>{
              dispatch(
                tagActions.fetchTags({
                  user_id: localStorage.getItem("user_text_obj_data1"),
                })
              );  
            }, 0);
    
          }
        } catch (e) {
          toast.info(`Error: ${e}`, { type: "error" });
        }
      };

  return (
    <>
    {/* <ToastContainer /> */}
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
        <Box className="tabpanel-data">
      <Box sx={{ width: "100%" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Box>
              <h3 style={{ textAlign: "center" }}>
              <Button className="top-nav-btn" variant="outlined">
                  <KeyboardBackspaceRoundedIcon
                    onClick={moveBack}
                    style={{ cursor: "pointer", float: 'left',marginLeft: '10px !important' }}
                  />
              </Button>
              
                Tag List <AddCircleOutlineIcon style={{color:'blue', cursor:'pointer'}} onClick={()=>{ setShowCreate( !showCreate); }}/>
                <Tooltip title="It is helpful to filter the expenses across multiple categories like tax saving, Expense over multiple insurances for the family etc.">
                  <HelpCenterIcon style={{cursor:'pointer'}}/>
                </Tooltip>
                </h3>
              </Box>
            <Demo style={{ minHeight: "500px" }}>
                {showCreate===true ? (
                    <Grid className="tag-form-container">
                        <form className="tag-form" style={{margin:'0px 10px'}}>
                            <Box style={{fontWeight:'500', padding:'10px 0px'}}>{inputField.tag_id && inputField.tag_id!=""  ? (<>Update</>):(<>Create New</>)} Tag</Box>
                            <TextField
                                value={inputField.name}
                                onChange={inputsHandler}
                                style={{ marginBottom: "10px", width: "100%" }}
                                type="text"
                                label="Name"
                                variant="outlined"
                                name="name"
                                maxLength={20}
                            />
                            <Box style={{height:"40px"}}>
                            <Button onClick={handleSubmit} variant="outlined" className="fl-rt">Save</Button>
                            </Box>
                            
                        </form>
                        
                    </Grid>
                ): (
                <></>
                )}
              {tagList ? (
                <List>
                  {tagList.length > 0 ? tagList.map((data, index) => (
                    <div key={index}>
                      <ListItem
                        secondaryAction={
                          <>
                            <IconButton
                              edge="end"
                              aria-label="remove"
                            >
                              <Tooltip title="Edit Tag">
                              <EditIcon onClick={()=> { showEditForm(data) }} />
                              </Tooltip>
                              
                            </IconButton>
                            {data.is_archived == '0' ? (
                              <IconButton style={{color:'green'}}
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                tagArchiveHandler(data.tag_id, "1", "Sure to archive?")
                              }
                            >
                                <Tooltip title="Click to Archive">
                                  <ArchiveOutlinedIcon />
                                </Tooltip>                              
                              </IconButton>
                            ): (
                              <IconButton style={{color:'red'}}
                              edge="end"
                              aria-label="remove"
                              onClick={() =>
                                tagArchiveHandler(data.tag_id, "0", "Sure to unarchive?")
                              }
                            >
                              <Tooltip title="Click to Unarchive">
                                <UnarchiveOutlinedIcon />
                              </Tooltip>                              
                              </IconButton>
                            )}
                          </>
                        }
                      >
                        <div className="content_budget">
                          <h4>
                            {index+1}. {data.name}
                          </h4>
                         

                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  )): <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                  No Data Available
              </Box>}
                </List>
              ) : (
                <>
                  {/* <div id="overlay">
                    <div className="loader">
                      <CircularProgress />
                    </div>
                  </div> */}
                </>
              )}
            </Demo>
          </Grid>
        </Grid>
      </Box>
    </Box>
        </Grid>
      </Grid>

    </>
  );
};

export default TagList;
